import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import CollectionDataConfigsEditRoute from './collection-data-configs/CollectionDataConfigsEditRoute';
import CollectionDataConfigsHomeRoute from 'routes/logged-in/collection-data-configs/CollectionDataConfigsHomeRoute';
import CreateCollectionDataConfigRoute from 'routes/logged-in/collection-data-configs/CreateCollectionDataConfigRoute';
import React, { FunctionComponent } from 'react';

export const CollectionDataConfigsRoute: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const location = useLocation();
  const match = useRouteMatch();

  return (
    <Switch location={location}>
      <Route path={`${match.path}/new`} component={CreateCollectionDataConfigRoute} />
      <Route path={`${match.path}/edit/:id`} component={CollectionDataConfigsEditRoute} />

      <Route component={CollectionDataConfigsHomeRoute} />
    </Switch>
  );
};
